<template>
  <section class="blog-post-link">
    <router-link v-bind:to="path">{{ title }}</router-link> <small>{{ date }}</small>
  </section>
</template>

<script>
export default {
  name: 'blog-post-link',
  props: ['title', 'date', 'path'],
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blog/blog-post-link.vue